module.exports = __webpack_public_path__ + "static/media/Double-arrow-right.4acc9d25.svg";